import { defineComponent } from 'vue';
import type { RouteRecordRaw } from 'vue-router';

import { NovaAuthorizationCapability } from '@/composables/useNovaAuthorization';
import { FeatureFlags } from '@/plugins/launchDarkly/featureFlags';

// Placeholder component for routes without views
const PlaceholderComponent = defineComponent({
  template: `
    <div class="q-pa-md">
      <h4>Page Under Development</h4>
      <p>This page is currently under development.</p>
    </div>
  `
});

export const paymentsRoutes: RouteRecordRaw[] = [
  {
    path: '/payments-and-billing',
    name: 'Payments',
    component: PlaceholderComponent,
    redirect: { name: 'PaymentsOverview' },
    meta: {
      requiresAuth: true,
      navigation: {
        label: 'Payments & Billing',
        icon: 'payments-icon.svg',
        order: 5,
        requiredCapability: NovaAuthorizationCapability.PAYMENTS_OVERVIEW_READ,
        showInMenu: true,
        featureFlag: FeatureFlags.PAYMENTS_INTEGRATION,
        permissions: {
          rbacRoles: ['dashboardnav-read']
        }
      }
    },
    children: [
      {
        path: 'overview/',
        name: 'PaymentsOverview',
        component: PlaceholderComponent,
        meta: {
          title: 'Payments & Billing - Overview',
          requiresAuth: true,
          navigation: {
            parent: 'Payments & Billing',
            parentIcon: 'payments-icon.svg',
            label: 'Overview',
            order: 1,
            requiredCapability: NovaAuthorizationCapability.PAYMENTS_OVERVIEW_READ,
            showInMenu: true,
            featureFlag: FeatureFlags.PAYMENTS_INTEGRATION,
            permissions: {
              ownerRoles: ['Publisher', 'Retailer']
            }
          }
        }
      },
      {
        path: 'wallets/',
        name: 'PaymentsWallets',
        component: PlaceholderComponent,
        meta: {
          title: 'Payments & Billing - Wallets',
          requiresAuth: true,
          navigation: {
            parent: 'Payments & Billing',
            parentIcon: 'payments-icon.svg',
            label: 'Wallets',
            order: 2,
            requiredCapability: NovaAuthorizationCapability.PAYMENTS_OVERVIEW_READ,
            showInMenu: true,
            featureFlag: FeatureFlags.PAYMENTS_INTEGRATION,
            permissions: {
              ownerRoles: ['Publisher', 'Retailer']
            }
          }
        }
      },
      {
        path: 'settings/',
        name: 'PaymentsSettings',
        component: PlaceholderComponent,
        meta: {
          title: 'Payments & Billing - Settings',
          requiresAuth: true,
          navigation: {
            parent: 'Payments & Billing',
            parentIcon: 'payments-icon.svg',
            label: 'Settings',
            order: 3,
            requiredCapability: NovaAuthorizationCapability.PAYMENTS_OVERVIEW_READ,
            showInMenu: true,
            featureFlag: FeatureFlags.PAYMENTS_INTEGRATION,
            permissions: {
              ownerRoles: ['Publisher', 'Retailer']
            }
          }
        }
      }
    ]
  }
];
